<template>
  <dialogModule
    width="40%"
    :title="$t('vipModule.createVipDialogTitle')"
    v-if="popupDialog"
    :dialogVisible="popupDialog"
    @close="closeDialog"
  >
    <span
      slot="close"
      class="el-icon-close close-icon"
      @click="closeDialog"
    ></span>
    <div slot="content" class="create-vip">
      <el-form
        ref="vipForm"
        size="small"
        label-position="top"
        label-width="auto"
        :model="form"
        :rules="rules"
        @submit.native.prevent
      >
        <el-row type="flex" :gutter="20" style="flex-wrap: wrap">
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipNickNameLabel')" prop="nickName">
              <el-input
                v-model="form.nickName"
                :placeholder="$t('vipModule.createVipNickNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipRealNameLabel')" prop="realName">
              <el-input
                v-model="form.realName"
                :placeholder="$t('vipModule.createVipRealNamePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipPhoneLabel')" prop="phone">
              <el-input
                v-model="form.phone"
                maxlength="11"
                :placeholder="$t('vipModule.createVipPhonePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipSexLabel')" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio label="1">{{ $t('vipModule.createVipSexMale') }}</el-radio>
                <el-radio label="0">{{ $t('vipModule.createVipSexFemale') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipDeptIdLabel')" prop="deptId">
              <el-select v-model="form.deptId" disabled :placeholder="$t('vipModule.createVipDeptIdPlaceholder')" style="width: 100%;">
                <el-option :value="deptId" :label="deptName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipAssistantUserIdLabel')" prop="assistantUserId">
              <el-select v-model="form.assistantUserId" :placeholder="$t('vipModule.createVipAssistantUserIdPlaceholder')" style="width: 100%;">
                <el-option v-for="item in shopList" :key="item.id" :value="item.id" :label="item.realName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipBirthdayLabel')" prop="birthday">
              <el-date-picker
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                  v-model="form.birthday"
                  type="date"
                  :placeholder="$t('vipModule.createVipBirthdayPlaceholder')">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipBirthdayCalendarTypeLabel')" prop="birthdayCalendarType">
              <el-radio-group v-model="form.birthdayCalendarType">
                <el-radio label="0">{{ $t('vipModule.createVipBirthdayCalendarSolar') }}</el-radio>
                <el-radio label="1">{{ $t('vipModule.createVipBirthdayCalendarLunar') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipIdNumLabel')" prop="idNum">
              <el-input
                v-model="form.idNum"
                :placeholder="$t('vipModule.createVipIdNumPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipCoatSizeLabel')" prop="coatSize">
              <el-input
                  v-model="form.coatSize"
                  :placeholder="$t('vipModule.createVipCoatSizePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipWaistlineLabel')" prop="waistline">
              <el-input
                  v-model="form.waistline"
                  :placeholder="$t('vipModule.createVipWaistlinePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipHeightLabel')" prop="height">
              <el-input
                  v-model="form.height"
                  :placeholder="$t('vipModule.createVipHeightPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipWeightLabel')" prop="weight">
              <el-input
                  v-model="form.weight"
                  :placeholder="$t('vipModule.createVipWeightPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('vipModule.createVipShoeSizeLabel')" prop="shoeSize">
              <el-input
                  v-model="form.shoeSize"
                  :placeholder="$t('vipModule.createVipShoeSizePlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="row align-center space-center">
          <el-button size="small" style="margin:0 10px 0 15px;border:1px solid #ccc;font-size: 15px;padding:8px 10px;" @click="closeDialog">{{ $t('vipModule.createVipCancelBtn') }}</el-button>
          <el-button size="small" type="primary" style="color:#fff;background:#067CF2;border:1px solid #067CF2;font-size: 15px;padding:8px 10px;" :disabled="loading" :loading="loading" @click="beforeCreate">{{ $t('vipModule.createVipConfirmBtn') }}</el-button>
      </div>
    </div>
  </dialogModule>
</template>

<script>
import dialogModule from "@/components/dialogModule.vue";
import {queryShoppGuide} from '@/libs/http/modules/posOrder'
import {vipSaveVipUserInfo} from "@/libs/http/modules/vip";
export default {
  components: {
    dialogModule,
  },
  data() {
    return {
      popupDialog: false,
      deptName: this.$cache.local.get('deptName'),
      deptId: this.$cache.local.get('deptId'),
      form: {
        nickName: '',//会员昵称
        realName: '',//真实姓名
        phone: '',//手机号
        sex: '1',//性别
        deptId: this.$cache.local.get('deptId'),//绑定店铺
        assistantUserId: '',//发卡导购
        birthday: '',//出生年月
        idNum: '',//身份证号
        coatSize: '',//上衣尺寸
        waistline: '',//腰围尺寸
        height: '',//身高
        weight: '',//体重
        shoeSize: '',//鞋码
        birthdayCalendarType:'',//生日历法类型
      },
      rules: {
        nickName: [{ required: true, message: this.$t('vipModule.createVipNickNameRequired'), trigger: 'blur' }],
        phone: [{ required: true, message: this.$t('vipModule.createVipPhoneRequired'), trigger: 'blur' }],
        sex: [{ required: true, message: this.$t('vipModule.createVipSexRequired'), trigger: 'blur' }],
      },
      loading: false,
      shopList: []
    };
  },
  created() {
    this.popupDialog = true;
    this.queryGuide();
  },
  methods: {
    async queryGuide() {
      this.shopListVisable = true;
      let data = await queryShoppGuide({ page: '1', pageSize: '50' });
      this.shopList = data.items || [];
    },
    closeDialog() {
      this.popupDialog = false;
      this.$emit("close");
    },
    beforeCreate(){
      this.$refs['vipForm'].validate(valid => {
        if (valid) {
          this.create();
        }
      });
    },
    create(){
      // if(!this.form.phone || !(/^1[3456789]\d{9}$/.test(this.form.phone))){
      //   return this.$message({ type: "error", message: this.$t('vipModule.createVipInvalidPhoneMsg'), duration: 2000, showClose: true });
      // }
      if(!this.form.phone){
        return this.$message({ type: "error", message: this.$t('vipModule.createVipInvalidPhoneMsg'), duration: 2000, showClose: true });
      }
      this.loading = true;
      let reqData = {}
      for(let key in this.form){
        if(this.form[key]){
          reqData[key] = this.form[key]
        }
      }
      vipSaveVipUserInfo(reqData).then(data=>{
        this.popupDialog = false;
        this.loading = false;
        this.$message({ type: "success", message: this.$t('vipModule.createVipCreateSuccessMsg'), duration: 2000, showClose: true });
        this.$emit("close", 'refresh');
      }).catch(error=>{
        this.loading = false;
        this.$message({ type: "error", message: error, duration: 2000, showClose: true });
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.create-vip{
  padding: 20px;
}
.close-icon {
  color: #999;
  padding: 10px;
  margin-right: -10px;
  cursor: pointer;
}
</style>

<style lang="scss">
.create-vip{
  .el-form-item__label{
    line-height: 0;
  }
  .el-form-item{
    margin-bottom: 20px;
  }
  .el-form-item__error{
    padding-top: 0;
  }
}
</style>

